export enum ActionType {
    LOAD_IMAGES = 'LOAD_IMAGES',
    LOAD_USER_IMAGES = 'LOAD_USER_IMAGES',
    LOAD_IMAGES_ERROR = 'LOAD_IMAGES_ERROR',
    ARCHIVE_IMAGE = 'ARCHIVE_IMAGE',
    TOGGLE_PRIVATE_IMAGE = 'TOGGLE_PRIVATE_IMAGE',
    SET_USER_UID = 'SET_USER_UID',
    CLEAR_IMAGES = 'CLEAR_IMAGES',
    SET_ASYNC_STATUS = 'SET_ASYNC_STATUS',
}
